export default Object.freeze([
  { value: 'ru-central1-a', label: 'ru-central1-a' },
  { value: 'ru-central1-b', label: 'ru-central1-b' },
  { value: 'ru-central1-c', label: 'ru-central1-c' },
]);
